import { cn } from "@utils/tw"
import { ComponentProps } from "react"

export function Spinner(props: ComponentProps<"div">) {
  return <span {...props} className={cn("spinner-indicator", props.className)}></span>
}
